import React from 'react';
import { Drawer, DrawerProps, styled, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/system';

interface styledDrawerProps extends DrawerProps {
  isMobile?: boolean,
  desktopWidth: string
}

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'desktopWidth'}
)<styledDrawerProps>(({ isMobile, desktopWidth, theme }) => ({
  zIndex: theme.zIndex.drawer + 2,
  '& .MuiDrawer-paper': {
    width: isMobile ? '100%' : desktopWidth
  },
}));

type ResponsiveDrawerProps = DrawerProps & {
  desktopWidth: string,
  onClosed?: () => void
}

export const ResponsiveDrawer: React.FC<ResponsiveDrawerProps> = (props: ResponsiveDrawerProps) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const {desktopWidth, onClosed, ...rest} = props;

  return (
    <StyledDrawer isMobile={isMobile} desktopWidth={desktopWidth} SlideProps={{onExited: onClosed}} {...rest}>
      {props.children}
    </StyledDrawer>
  );
};

